import { FC } from 'react';
import { useToggleCart } from 'hooks/cart/useToggleCart';
import * as Styled from './styles';
import { useAppSelector } from 'appRedux/hooks';
import { TSizeType } from 'interfaces';

type TCartProps = {
  size?: TSizeType;
};

export const Cart: FC<TCartProps> = ({ size = 'large' }) => {
  const {
    info: { items_count }
  } = useAppSelector(({ cart }) => cart);
  const { handleToggleCart } = useToggleCart();

  return (
    <Styled.CartWrapper $size={size} onClick={() => handleToggleCart(true)}>
      <Styled.CartIcon />
      {!!items_count && (
        <Styled.CartCountChip>{items_count}</Styled.CartCountChip>
      )}
    </Styled.CartWrapper>
  );
};
